import TiptapTable from '@tiptap/extension-table'
import TiptapTableRow from '@tiptap/extension-table-row'
import TiptapTableHeader from '@tiptap/extension-table-header'
import { mergeAttributes, Node } from '@tiptap/core'

export const TableServerside = TiptapTable.configure({
  resizable: false,
})

export const TableRowServerside = TiptapTableRow.extend({
  allowGapCursor: false,
})

export const TableHeaderServerside = TiptapTableHeader.extend({
  addAttributes() {
    return {
      colspan: {
        default: 1,
      },
      rowspan: {
        default: 1,
      },
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute('colwidth')
          return colwidth ? colwidth.split(',').map((item) => parseInt(item, 10)) : null
        },
      },
      style: {
        default: null,
      },
    }
  },
})

interface TableCellServersideOptions {
  HTMLAttributes: Record<string, unknown>
}

export const TableCellServerside = Node.create<TableCellServersideOptions>({
  name: 'tableCell',

  content: 'block+',

  tableRole: 'cell',

  isolating: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [{ tag: 'td' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['td', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addAttributes() {
    return {
      colspan: {
        default: 1,
        parseHTML: (element) => {
          const colspan = element.getAttribute('colspan')
          return colspan ? parseInt(colspan, 10) : 1
        },
      },
      rowspan: {
        default: 1,
        parseHTML: (element) => {
          const rowspan = element.getAttribute('rowspan')
          return rowspan ? parseInt(rowspan, 10) : 1
        },
      },
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute('colwidth')
          return colwidth ? [parseInt(colwidth, 10)] : null
        },
      },
      style: {
        default: null,
      },
    }
  },
})
